module.exports = __webpack_public_path__ + "img/jackpot-bg_1920.26ec1f4e.png";